import Tennis from "./Tennis";

export default Tennis;